import {
    AntecedentesCatalogsDto,
    CreateShippingInstructionItemDto,
    CreateShippingInstructionSpeciesDto,
    FreightCondition,
} from '@opb-workspace/shared';
import {
    catalogItemName,
    coldTreatmentLabel,
    containerTypeLabel,
    controlledAtmosphereLabel,
    freightConditionLabel,
    palletTypeLabel,
    speciesPackageTypeLabel,
    ventilationUnitLabel,
    yesNo,
} from './step4-revision.helpers';
import type { Step4CatalogSnapshot } from './step4-catalog-snapshot';

type Cat = Step4CatalogSnapshot;

/** Funciones puras para textos del resumen (paso 4). */
export const Step4Labels = {
    clauseOfSale(id: number | undefined, ant: AntecedentesCatalogsDto): string {
        return catalogItemName(ant.clauseOfSales, id);
    },

    typeOfCargo(id: number | undefined, ant: AntecedentesCatalogsDto): string {
        return catalogItemName(ant.typeOfCargoes, id);
    },

    methodOfPayment(
        id: number | undefined,
        ant: AntecedentesCatalogsDto,
    ): string {
        return catalogItemName(ant.methodOfPayments, id);
    },

    modeOfSale(id: number | undefined, ant: AntecedentesCatalogsDto): string {
        return catalogItemName(ant.modeOfSales, id);
    },

    freight(fc?: FreightCondition | null): string {
        return freightConditionLabel(fc);
    },

    yn(value: boolean | undefined | null): string {
        return yesNo(value);
    },

    containerType(it: CreateShippingInstructionItemDto, snap: Cat): string {
        return containerTypeLabel(
            snap.containerPackageTypes,
            it.containerTypeId,
            it.containerType,
        );
    },

    palletType(it: CreateShippingInstructionItemDto, snap: Cat): string {
        return palletTypeLabel(
            snap.palletPackageTypes,
            it.palletTypeId,
            it.palletType,
        );
    },

    coldTreatment(it: CreateShippingInstructionItemDto, snap: Cat): string {
        return coldTreatmentLabel(
            snap.coldTreatmentIndicators,
            it.coldTreatmentIndicatorId,
            it.coldTreatment,
        );
    },

    atmosphere(it: CreateShippingInstructionItemDto, snap: Cat): string {
        return controlledAtmosphereLabel(
            snap.controlledAtmospheres,
            it.controlledAtmosphereId,
            it.atmosphere,
        );
    },

    ventilationUnit(it: CreateShippingInstructionItemDto, snap: Cat): string {
        return ventilationUnitLabel(
            snap.ventilationUnits,
            it.ventilationUnitId,
            it.ventilationUnit,
        );
    },

    ventilationLine(it: CreateShippingInstructionItemDto, snap: Cat): string {
        const u = Step4Labels.ventilationUnit(it, snap);
        const v = it.ventilation;
        if (v == null && !u) {
            return '';
        }
        if (v != null && u) {
            return `${v} ${u}`;
        }
        if (v != null) {
            return String(v);
        }
        return u;
    },

    speciesPackage(
        sp: CreateShippingInstructionSpeciesDto,
        snap: Cat,
    ): string {
        return speciesPackageTypeLabel(
            snap.speciesPackageTypes,
            sp.typeOfPackageId,
            sp.packageType,
        );
    },
};
